/**
 * @generated SignedSource<<676abc8b0bda775e752c758d28646354>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableDetailsTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_viewer" | "PdpRespSharedSellerDetails_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableDetailsTabs_viewer";
};
export type PdpRespUnavailableDetailsTabs_viewer$key = {
  readonly " $data"?: PdpRespUnavailableDetailsTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableDetailsTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableDetailsTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSellerDetails_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b26a4b337d4967201a4dbd6b981c280e";

export default node;
